import celebrations2x from "./assets/celebrations@2x.webp";
import celebrations3x from "./assets/celebrations@3x.webp";
import celebrations1x from "./assets/celebrations.webp";
import deleteConfirmation2x from "./assets/delete-confirmation@2x.webp";
import deleteConfirmation3x from "./assets/delete-confirmation@3x.webp";
import deleteConfirmation1x from "./assets/delete-confirmation.webp";
import error2x from "./assets/error@2x.webp";
import error3x from "./assets/error@3x.webp";
import error1x from "./assets/error.webp";
import experience2x from "./assets/experience@2x.webp";
import experience3x from "./assets/experience@3x.webp";
import experience1x from "./assets/experience.webp";
import messages2x from "./assets/messages@2x.webp";
import messages3x from "./assets/messages@3x.webp";
import messages1x from "./assets/messages.webp";
import openSoon2x from "./assets/open-soon@2x.webp";
import openSoon3x from "./assets/open-soon@3x.webp";
import openSoon1x from "./assets/open-soon.webp";
import photos2x from "./assets/photos@2x.webp";
import photos3x from "./assets/photos@3x.webp";
import photos1x from "./assets/photos.webp";
import products2x from "./assets/products@2x.webp";
import products3x from "./assets/products@3x.webp";
import products1x from "./assets/products.webp";
import programs2x from "./assets/programs@2x.webp";
import programs3x from "./assets/programs@3x.webp";
import programs1x from "./assets/programs.webp";
import restricted2x from "./assets/restricted@2x.webp";
import restricted3x from "./assets/restricted@3x.webp";
import restricted1x from "./assets/restricted.webp";
import reviews2x from "./assets/reviews@2x.webp";
import reviews3x from "./assets/reviews@3x.webp";
import reviews1x from "./assets/reviews.webp";
import trips2x from "./assets/trips@2x.webp";
import trips3x from "./assets/trips@3x.webp";
import trips1x from "./assets/trips.webp";

export interface IllustrationDensitySet {
  x1: string;
  x2: string;
  x3: string;
}

export const illustrationMap = {
  celebrations: { x1: celebrations1x, x2: celebrations2x, x3: celebrations3x },
  "delete-confirmation": { x1: deleteConfirmation1x, x2: deleteConfirmation2x, x3: deleteConfirmation3x },
  error: { x1: error1x, x2: error2x, x3: error3x },
  experience: { x1: experience1x, x2: experience2x, x3: experience3x },
  messages: { x1: messages1x, x2: messages2x, x3: messages3x },
  "open-soon": { x1: openSoon1x, x2: openSoon2x, x3: openSoon3x },
  photos: { x1: photos1x, x2: photos2x, x3: photos3x },
  products: { x1: products1x, x2: products2x, x3: products3x },
  programs: { x1: programs1x, x2: programs2x, x3: programs3x },
  restricted: { x1: restricted1x, x2: restricted2x, x3: restricted3x },
  reviews: { x1: reviews1x, x2: reviews2x, x3: reviews3x },
  trips: { x1: trips1x, x2: trips2x, x3: trips3x },
} as const satisfies Record<string, IllustrationDensitySet>;

export type IllustrationName = keyof typeof illustrationMap;
